import React from "react";

export const AccountDisplay = ({ item, year, month, date, fullAccountName }) => {
    // Проверяем, что item и item.account существуют
    const accountName = item?.account?.name;

    // Если имя аккаунта отсутствует, можно отобразить заглушку или просто пустую ячейку
    const account = accountName && accountName.length > 16
        ? accountName.substr(0, 15) + '...'
        : accountName || '--'; // или '', 'N/A', etc.

    return (
        <div data-tooltip-content={fullAccountName}>
            {account}
        </div>
    );
};